/*
 * WEB-3597 — Centralised HTML sanitiser for rich-text render sinks.
 *
 * Category-B follow-up to WEB-3596. WEB-3596 added window.ssEscapeHtml for
 * PLAIN-TEXT fields wrongly injected as HTML. This helper is the complement for
 * fields that INTENTIONALLY hold rich text — e.g. PropertyQuestion.question_text
 * and Selection.selection_text — which are rendered via ng-bind-html through the
 * ~18 controller renderHtml() helpers that hand content to $sce.trustAsHtml().
 *
 * Those fields legitimately contain formatting (bold / links / lists / tables),
 * so they must be allow-list SANITISED, not escaped (escaping destroys the
 * formatting — the WEB-3592 iteration-1 mistake). Route every renderHtml()
 * through this function so $sce.trustAsHtml() only ever receives HTML that has
 * had <script>, inline event-handler attributes (onerror/onload/…) and
 * javascript: URLs stripped, while keeping the formatting tags.
 *
 * Lives in core/ so gulp concatenates it into public/js/core.js, which the
 * layout blades load (as a plain <script>) BEFORE the rollup'd view/component
 * bundles — so window.ssSanitizeHtml is defined before any view runtime code
 * calls it. DOMPurify is bundled into public/js/vendor.js (loaded ahead of
 * core.js), exposing the global window.DOMPurify this helper relies on.
 *
 * The defence is intentionally library-driven: DOMPurify's default profile is a
 * well-vetted allow-list that keeps the rich-text formatting these fields need
 * while removing every known XSS vector. Keep the configuration centralised here
 * so any future tweak (e.g. an extra allowed tag for a document template) is a
 * single-point change applied to every sink at once.
 */
(function (window) {
    'use strict';

    /**
     * Allow-list sanitise an HTML string before it is handed to
     * $sce.trustAsHtml() / ng-bind-html.
     *
     * @param {*} html The rich-text HTML to sanitise. null / undefined become ''.
     * @returns {string} Sanitised HTML safe for rendering (formatting preserved,
     *          scripts / event-handler attributes / javascript: URLs removed).
     */
    function ssSanitizeHtml(html) {
        if (html === null || html === undefined) {
            return '';
        }

        var input = String(html);
        var purifier = window.DOMPurify;

        if (!purifier || typeof purifier.sanitize !== 'function') {
            // DOMPurify failed to load (build/ordering problem). Fail SAFE by
            // HTML-escaping so nothing can execute — formatting is lost but the
            // page stays secure. This should never happen in practice because
            // purify.min.js is bundled into vendor.js ahead of core.js.
            if (window.console && typeof window.console.warn === 'function') {
                window.console.warn('ssSanitizeHtml: DOMPurify unavailable; falling back to HTML-escaping.');
            }

            return typeof window.ssEscapeHtml === 'function' ? window.ssEscapeHtml(input) : '';
        }

        return purifier.sanitize(input);
    }

    window.ssSanitizeHtml = ssSanitizeHtml;
})(window);
